import { Symbols } from '@leverege/ui-mapbox-elements'

exports.create = ( onReady ) => {
  const sm = 32
  const lg = 40
  const xl = 50

  const symbols = new Symbols( onReady )
  symbols.addImage( 'recent', { src : '/assets/images/map-icons/circle-green.svg', width : sm, height : sm } )
  symbols.addImage( 'recent-rollover', { src : '/assets/images/map-icons/circle-green.svg', width : lg, height : lg } )
  symbols.addImage( 'recent-selected', { src : '/assets/images/map-icons/circle-green-selected.svg', width : lg, height : lg } )
  symbols.addImage( 'recent-selected-rollover', { src : '/assets/images/map-icons/circle-green-selected.svg', width : xl, height : xl } )

  symbols.addImage( 'recent-targeted', { src : '/assets/images/map-icons/circle-blue.svg', width : sm, height : sm } )
  symbols.addImage( 'recent-targeted-rollover', { src : '/assets/images/map-icons/circle-blue.svg', width : lg, height : lg } )
  symbols.addImage( 'recent-targeted-selected', { src : '/assets/images/map-icons/circle-blue-selected.svg', width : lg, height : lg } )
  symbols.addImage( 'recent-targeted-selected-rollover', { src : '/assets/images/map-icons/circle-blue-selected.svg', width : xl, height : xl } )
  return symbols
}
